export enum Network {
  DEVNET = "devnet",
  TESTNET = "testnet",
  MAINNET_BETA = "mainnet-beta",
}

export type CandyMachineId = string;
export type Host = string;
